import React, { useCallback, useMemo } from "react"

import { JsonCodeEditor } from "@/components/JsonCodeEditor"
import { FieldLabel } from "@/components/shared/forms/FieldLabel"
import {
  JSON_TEMPLATE_FIELDS,
  validateJsonTemplate,
} from "@/utils/validation/jsonTemplateValidation"

import { WEBSOCKET_TOOLTIPS } from "./tooltips"
import { DEFAULT_MEDIA_TEMPLATE, type WebSocketFieldProps } from "./types"

export const MediaFormatFields: React.FC<WebSocketFieldProps> = ({
  metadata,
  onMetadataUpdate,
  disabled = false,
}) => {
  const mediaTemplateError = useMemo(
    () =>
      validateJsonTemplate(
        metadata.send_media_template,
        JSON_TEMPLATE_FIELDS.media,
      ),
    [metadata.send_media_template],
  )

  const handleMediaTemplateChange = useCallback(
    (value: string) => {
      onMetadataUpdate({ send_media_template: value })
    },
    [onMetadataUpdate],
  )

  return (
    <div className="space-y-4">
      <h4 className="text-sm font-medium text-coval-text">Media Format</h4>

      <div className="space-y-2">
        <FieldLabel tooltip={WEBSOCKET_TOOLTIPS.sendMediaTemplate}>
          Media Send Template
        </FieldLabel>
        <JsonCodeEditor
          hideGutters
          copyable
          ariaLabel="Media Send Template"
          placeholder={DEFAULT_MEDIA_TEMPLATE}
          value={metadata.send_media_template || ""}
          onChange={handleMediaTemplateChange}
          rows={6}
          disabled={disabled}
          error={mediaTemplateError}
          // Raw binary mode uses the bare `{{media_data}}` template, which a
          // plain JSON parse rejects.
          lint={false}
        />
      </div>
    </div>
  )
}
